import { useEffect, useState } from "react";
import { fetchPresenceOverview } from "../api/productTablesApi";

const REFRESH_MS = 30000;

/** Who else is working right now, per project: { [projectId]: [{ user_id, name, last_seen }] }. */
export function usePresenceOverview(token) {
  const [online, setOnline] = useState({});

  useEffect(() => {
    if (!token) {
      setOnline({});
      return undefined;
    }
    let cancelled = false;
    const load = async () => {
      if (document.hidden) return;
      try {
        const data = await fetchPresenceOverview(token);
        if (!cancelled) setOnline(data && typeof data === "object" ? data : {});
      } catch {
        /* transient — try again next tick */
      }
    };
    load();
    const timer = setInterval(load, REFRESH_MS);
    return () => {
      cancelled = true;
      clearInterval(timer);
    };
  }, [token]);

  return online;
}
